import React, { useEffect, useContext, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import AppContext from '../../../App/AppContext';
import { Container } from '@material-ui/core';
import '../../Auditor/Dashboard/dashboard.scss';
import CommentIcon from '@material-ui/icons/Comment';
import TimerIcon from '@material-ui/icons/Timer';
import GroupWorkIcon from '@material-ui/icons/GroupWork';
import DepartureBoardIcon from '@material-ui/icons/DepartureBoard';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import BuildIcon from '@material-ui/icons/Build';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import { SecondaryButton } from '../../../Core/FormInput';
import { getCommunicatorDash } from '../../../Core/Service/CustUserCommunicator/communicator-service';
import { AppStorage } from '../../../Core/Service/storage-service';
import { RenderTiles } from '../CustCommonDash';
import BookingRequestedModal from '../bookingRequested/bookingRequestedModal';

const CustCommunicatorDash = () => {
    const [state, setState] = useState({
        communicatorData: {},
        communicatorLog: [],
        isReload: null,
        isBookingRequesteModal: false
    });
    const { showToast, userRoles } = useContext(AppContext);
    const isCustomer = userRoles.includes('customer');
    const isInternal = userRoles.includes('internal');
    const statusObject = AppStorage.getTCardStatus();

    let statusList = JSON.parse(statusObject);

    useEffect(() => {
        (async () => {
            const resp = await getCommunicatorDash();
            if (resp.success) {
                const log = resp.data.communicatorLog || [];
                setState((st) => ({
                    ...st,
                    communicatorData: resp.data.list[0] || {},
                    communicatorLog: log.map((m, i) => ({
                        id: `log-${m.id}`,
                        name: m.cb,
                        color: '#3498db',
                        icon: <CommentIcon />,
                        count: m.count,
                        url: '/Openactionlog'
                    }))
                }));
            } else {
                showToast(resp.message);
            }
        })();
    }, [state.isReload, showToast]);

    const CommunicatorBookingsSec = [
        {
            id: 'siteveh',
            name: 'SITE VEHICLES',
            color: '#dc3545',
            // icon: <DriveEtaIcon />,
            count: state.communicatorData.siteVehiclesCount,
            url: {
                pathname: '/tCards_List',
                search: '?SiteVehicle=true'
            },
            isShowCustomer: true
        },
        {
            id: 'noShow',
            name: 'NO SHOW',
            color: '#3498db',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.noShow,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=8'
            },
            isShowCustomer: true
        },
        {
            id: 'totalCount',
            name: 'Total',
            color: '#3498db',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.totalCount,
            url: {
                pathname: '/tCards_List',
                search: ''
            },
            isShowCustomer: true
        },
        {
            id: 'collect',
            name: 'AWAITING COLLECTION',
            color: '#dc3545',
            // icon: <DepartureBoardIcon />,
            count: state.communicatorData.awaitingCollectionCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=9'
            },
            isShowCustomer: true
        },
        {
            id: 'readyForCollection',
            name: 'READY FOR COLLECTION',
            color: '#dc3545',
            // icon: <DepartureBoardIcon />,
            count: state.communicatorData.readyForCollection,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=13'
            },
            isShowCustomer: true
        },
        {
            id: 'tbsched',
            name: 'TO BE SCHEDULED',
            color: '#3498db',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.bookingCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=0'
            },
            isShowCustomer: true
        },
        {
            id: 'callback',
            name: 'AWAITING CALLBACK',
            color: '#3498db',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.awaitingCallBack,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=7'
            },
            isShowCustomer: true
        }
    ];

    const CommunicatorMemberSecOne = [
        {
            id: 'confirmed',
            name: 'BOOKING CONFIRMED',
            color: '#2ecc71',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.bookingConfirmedCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=1'
            },
            isShowCustomer: true
        },
        {
            id: 'inProgressCount',
            name: 'IN PROGRESS',
            color: '#2ecc71',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.inProgressCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=3'
            },
            isShowCustomer: true
        },
        {
            id: 'motprep',
            name: 'MOT PREP',
            color: '#3498db',
            // icon: <DriveEtaIcon />,
            count: state.communicatorData.motPrep,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=6'
            },
            isShowCustomer: true
        },
        {
            id: 'workOutstandingCount',
            name: 'WORK OUTSTANDING',
            color: '#2ecc71',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.workOutstandingCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=14'
            },
            isShowCustomer: true
        },
        {
            id: 'workCompletedCount',
            name: 'WORK COMPLETED',
            color: '#2ecc71',
            // icon: <EventAvailableIcon />,
            count: state.communicatorData.workCompletedCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=12'
            },
            isShowCustomer: true
        }
        // {
        //     id: 'auth',
        //     name: 'AWAITING AUTHORITY',
        //     color: '#dc3545',
        //     // icon: <TimerIcon />,
        //     count: state.communicatorData.awaitingAuthorityCount,
        //     url: {
        //         pathname: '/tCards_List',
        //         search: '?StatusID=4'
        //     }
        // },
        // {
        //     id: 'parts',
        //     name: 'PARTS ON ORDER',
        //     color: '#dc3545',
        //     // icon: <GroupWorkIcon />,
        //     count: state.communicatorData.awaitingPartsCount,
        //     url: {
        //         pathname: '/tCards_List',
        //         search: '?StatusID=5'
        //     }
        // }
    ];

    const CommunicatorMemberSecTwo = [
        {
            id: 'unassigned',
            name: 'AWAITING START',
            color: '#3498db',
            // icon: <BuildIcon />,
            count: state.communicatorData.checkedInCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=2'
            }
        },
        {
            id: 'parts',
            name: 'PARTS ON ORDER',
            color: '#dc3545',
            // icon: <GroupWorkIcon />,
            count: state.communicatorData.awaitingPartsCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=5'
            }
        },
        {
            id: 'auth',
            name: 'AWAITING AUTHORITY',
            color: '#dc3545',
            // icon: <TimerIcon />,
            count: state.communicatorData.awaitingAuthorityCount,
            url: {
                pathname: '/tCards_List',
                search: '?StatusID=4'
            }
        }
        // {
        //     id: 'inprog',
        //     name: 'IN PROGRESS',
        //     color: '#2ecc71',
        //     icon: <BuildIcon />,
        //     count: state.communicatorData.workshopCount,
        //     url: {
        //         pathname: '/tCards_List',
        //         search: '?StatusID=3'
        //     }
        // },
        // {
        //     id: 'assigned',
        //     name: 'ASSIGNED',
        //     color: '#3498db',
        //     icon: <BuildIcon />,
        //     count: state.communicatorData.assigned,
        //     url: {
        //         pathname: '/tCards_List',
        //         search: '?StatusID=11'
        //     }
        // }
    ];

    const header = (
        <div style={{ position: 'relative', paddingBottom: 10 }}>
            <SecondaryButton onClick={() => setState((st) => ({ ...st, isBookingRequesteModal: true }))}>Request Booking</SecondaryButton>
        </div>
    );

    let CommunicatorColOne = CommunicatorBookingsSec.map((c) => {
        let findStatus = statusList.find((s) => s.status === c.name);
        return {
            ...c,
            color: findStatus ? findStatus.bgc : c.color,
            txtColor: findStatus ? findStatus.tc : '',
            isTcard: true
        };
    });
    let CommunicatorColSec = CommunicatorMemberSecOne.map((c) => {
        let findStatus = statusList.find((s) => s.status === c.name);
        return {
            ...c,
            color: findStatus ? findStatus.bgc : c.color,
            txtColor: findStatus ? findStatus.tc : '',
            isTcard: true
        };
    });
    let CommunicatorColThird = CommunicatorMemberSecTwo.map((c) => {
        let findStatus = statusList.find((s) => s.status === c.name);
        return {
            ...c,
            color: findStatus ? findStatus.bgc : c.color,
            txtColor: findStatus ? findStatus.tc : '',
            isTcard: true
        };
    });

    return (
        <Container maxWidth="xl" style={{ padding: 16 }}>
            {AppStorage.getCommunicatorAllowed() && (
                <Grid container spacing={3}>
                    {isCustomer ? (
                        <>
                            <Grid item xs={12}>
                                <RenderTiles cards={CommunicatorMemberSecOne.filter((c) => c.isShowCustomer)} />
                            </Grid>
                            <Grid item xs={12}>
                                <RenderTiles cards={CommunicatorBookingsSec.filter((c) => c.isShowCustomer)} label={header} />
                            </Grid>
                        </>
                    ) : isInternal ? (
                        <>
                            <Grid item xs={12}>
                                <RenderTiles cards={CommunicatorColOne} />
                            </Grid>
                            <Grid item xs={12}>
                                <RenderTiles cards={CommunicatorColSec} />
                            </Grid>
                            <Grid item xs={12}>
                                <RenderTiles cards={CommunicatorColThird} />
                            </Grid>
                            <Grid item xs={12}>
                                <RenderTiles cards={state.communicatorLog} />
                            </Grid>
                        </>
                    ) : null}
                </Grid>
            )}
            {state.isBookingRequesteModal && (
                <BookingRequestedModal
                    onClose={(reload) => setState((st) => ({ ...st, isBookingRequesteModal: false, ...(reload && { isReload: new Date() }) }))}
                />
            )}
        </Container>
    );
};

export default CustCommunicatorDash;
